import React, { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { useForm } from "react-hook-form";
import { courseTypeOptions } from "../../../../utils/const";
import { Message } from "primereact/message";

const SearchModal = ({
  toggleModal,
  setCourseType,
  courseType,
  setFromDate,
  fromDate,
  setToDate,
  toDate,
  setPagination }) => {

  const {
    register,
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      courseType: {
        value: courseType,
        label: courseType == "" ? "-- PILIH SALAH SATU --" : courseType,
      },
      fromDate: fromDate,
      toDate: toDate
    },
  });

  const toDateInput = watch('toDate');

  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    toggleModal(false);
  };

  const handleSave = async (formData) => {
    setLoading(true);
    setPagination({ first: 0, rows: 10, page: 0 });
    setCourseType(formData.courseType.value);
    setFromDate(formData.fromDate);
    setToDate(formData.toDate);
    setLoading(false);
    closeModal();
  };

  return (
    <Modal show={toggleModal} onHide={closeModal} size="md">
      <Modal.Header closeButton>
        <Modal.Title>
          <h6>Filter Jadwal</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>

        {/* COURSE TYPE */}
        <div className="row mb-3">
          <div className="col-md-6">
            <div className="form-group">
              <label className="form-label">Tipe Pertemuan</label>
              <Controller
                control={control}
                name="courseType"
                render={({ field }) => (
                  <Select
                    value={field.value}
                    options={courseTypeOptions}
                    onChange={(value) => field.onChange(value)}
                  />
                )}
              />
            </div>
          </div>
        </div>

        <div className="row mb-3">

          {/* FROM DATE */}
          <div className="col-md-6">
            <div className="form-group">
              <label className="form-label">Dari Tanggal</label>
              <input
                {...register('fromDate', {
                  required: toDateInput !== '' ? 'Kolom ini wajib diisi' : false,
                })}
                type="date"
                className="form-control"
              />
              {errors.fromDate && (
                <div className="">
                  <Message
                    className="mt-2 d-flex"
                    severity="error"
                    text={errors.fromDate.message}
                  />
                </div>
              )}
            </div>
          </div>

          {/* TO DATE */}
          <div className="col-md-6">
            <div className="form-group">
              <label className="form-label">Sampai Tanggal</label>
              <input
                {...register("toDate")}
                type="date"
                className="form-control"
              />
            </div>
          </div>


        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>
          Batal
        </Button>
        <Button
          variant="success"
          disabled={loading}
          onClick={handleSubmit(handleSave)}
        >
          {loading && (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          )}
          <span className="ml-1">Filter</span>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SearchModal;
